import { z } from 'zod';

/**
 * Canonical user identity in an environment (DAT-001): the VCG customer id as a string. Email and phone are
 * attributes, never identities, so `@` is rejected outright.
 */
export const ExternalId = z
  .string()
  .min(1)
  .max(128)
  .regex(/^[^\s@\p{Cc}]+$/u, 'external_id_invalid');

/** Server-side alias (`/users/identify` analogue, DAT-002): unique `name` within a `label`. */
export const AliasRef = z.strictObject({
  label: z.string().regex(/^[a-z][a-z0-9_]{0,63}$/, 'alias_label_invalid'),
  name: z.string().min(1).max(255),
});

/** How the server API addresses a user: exactly one of external id or alias. */
export const UserRef = z.union([z.strictObject({ externalId: ExternalId }), z.strictObject({ alias: AliasRef })]);

/** Identity header of every SDK batch (BB-25): `epoch` increments on every identity change in the SDK. */
export const SdkIdentity = z.strictObject({
  externalId: ExternalId.nullable(),
  epoch: z.number().int().min(0).max(2_147_483_647),
});

export type ExternalId = z.infer<typeof ExternalId>;
export type AliasRef = z.infer<typeof AliasRef>;
export type UserRef = z.infer<typeof UserRef>;
export type SdkIdentity = z.infer<typeof SdkIdentity>;
